/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from "react"
import cx from "classnames"

import { Checkbox, CheckboxProps as MantineCHeckboxProps } from "@mantine/core"
import { CheckboxProps as MUICheckboxProps } from "@mui/material"
import withMappedProps from "hoc-lib/propsMapping"

import styles from "./Checkbox.mantine.module.scss"

export const MantineCheckbox = Checkbox

export default MantineCheckbox

interface IconInterpolatorProps {
  checked?: boolean
  indeterminate?: boolean
  indeterminateIcon?: React.ReactNode
  icon: React.ReactNode
  checkedIcon: React.ReactNode
}

const IconInterpolator = (props: IconInterpolatorProps) => (
  <>
    {props.indeterminate
      ? props.indeterminateIcon
      : props.checked
      ? props.checkedIcon
      : props.icon}
  </>
)

const muiToMantine = (props: MUICheckboxProps): MantineCHeckboxProps => {
  const newProps: any = { ...props }
  return {
    ...newProps,
    ...props.inputProps,
    icon: props.icon
      ? ({ indeterminate, className }) => (
          <IconInterpolator
            checked={props.checked}
            indeterminate={props.indeterminate}
            icon={props.icon}
            checkedIcon={props.checkedIcon}
            indeterminateIcon={props.indeterminateIcon}
          />
        )
      : undefined,
    value: props.value,
    checked: props.checked,
    indeterminate: props.indeterminate,
    classNames: {
      ...styles,
    },
  }
}

export const MUIMappedCheckbox = withMappedProps(MantineCheckbox, muiToMantine)
